import fetchApi from "../../../lib/fetchApi";

export const updateLanguageAPI = async ( language: string): Promise<void> => {
    await fetchApi.get(`/auth/language/${language}`);
};

